import React from "react";
import { withRouter, Link, useLocation, useNavigate } from "react-router-dom";
import { Input, } from 'reactstrap'
import { Navigation } from "./navigation";
import { Button } from "bootstrap";


export function Signup() {

    const navigate = useNavigate();
    const location = useLocation();

    const [formData, setData] = React.useState({});
    const [user, setUser] = React.useState({});
    const [disable, setDisable] = React.useState(false);
    const [showAppPrompt, setShowAppPrompt] = React.useState(false);
    const [signedUpUser, setSignedUpUser] = React.useState(null);
    const [plan, setPlan] = React.useState('team');
    const [billingInterval, setBillingInterval] = React.useState('monthly');
    const [stripeSessionId, setStripeSessionId] = React.useState('');
    const [stripeSessionValidated, setStripeSessionValidated] = React.useState(false);

    React.useEffect(() => {
        const params = new URLSearchParams(location.search || '');
        const requestedPlan = String(params.get('plan') || '').toLowerCase();
        const requestedInterval = String(params.get('billingInterval') || '').toLowerCase();
        const sessionId = String(params.get('session_id') || '').trim();

        const hasValidPlan = ['team', 'business', 'enterprise'].includes(requestedPlan);
        const hasValidInterval = ['monthly', 'annual'].includes(requestedInterval);

        if (!hasValidPlan || !hasValidInterval) {
            navigate('/pricing');
            return;
        }

        setPlan(requestedPlan);
        setBillingInterval(requestedInterval);
        setStripeSessionId(sessionId);

        if (!sessionId) {
            setStripeSessionValidated(false);
            return;
        }

        fetch(`https://crewcoin.herokuapp.com/billing/checkout-session/${encodeURIComponent(sessionId)}`)
            .then((res) => res.json())
            .then((data) => {
                if (!data?.success || !data?.session || (data?.session?.paymentStatus !== 'paid' && data?.session?.status !== 'complete')) {
                    alert('Stripe payment session is missing or incomplete. Please try checkout again.');
                    navigate('/pricing');
                    return;
                }

                const sessionEmail = String(data?.session?.customerEmail || '').toLowerCase();
                if (sessionEmail) {
                    setData((prev) => ({ ...prev, username: sessionEmail }));
                }
                setStripeSessionValidated(true);
            })
            .catch(() => {
                alert('Unable to verify Stripe session. Please try again.');
                navigate('/pricing');
            });
    }, [location.search, navigate]);


    function handleForm() {
        if (formData.siteNumber === undefined || formData.siteNumber === null || formData.siteNumber === "") {
            alert("Please enter a site number");
            setTimeout(() => {
                setDisable(false)
            }, 2000)
        }
        else {
            fetch("https://crewcoin.herokuapp.com/crewuser/signup", {
                method: "POST",
                headers: {
                    authorization: "jwt",
                    credentials: "same-origin",
                    Accept: "application/json, text/html, */*",
                    "Content-Type": "application/json",
                    mode: "cors"
                },
                body: JSON.stringify({
                    "admin": true,
                    "username": formData.username,
                    "password": formData.password,
                    "firstname": formData.firstName[0].toUpperCase() + formData.firstName.substring(1),
                    "lastname": formData.lastName[0].toUpperCase() + formData.lastName.substring(1),
                    "phone": formData.phone,
                    "organization": formData.organization[0].toUpperCase() + formData.organization.substring(1),
                    "portalId": formData.siteNumber,
                    "type": formData.type,
                    "plan": plan,
                    "billingInterval": billingInterval,
                }),
            })

                .then(res => res.json())
                .then(res => {
                    console.log(res)
                    if (res.success) {
                        setUser(res.user);
                        setSignedUpUser(res.user);
                        localStorage.setItem("token", res.token);

                        const shouldBill = Boolean(res.user?.admin && !res.user?.isGrandfathered && res.user?.billingStatus !== 'active' && res.user?.billingStatus !== 'trialing');

                        if (shouldBill && stripeSessionId && stripeSessionValidated) {
                            fetch("https://crewcoin.herokuapp.com/billing/attach-session", {
                                method: "POST",
                                headers: {
                                    Accept: "application/json",
                                    "Content-Type": "application/json",
                                },
                                body: JSON.stringify({
                                    userId: res.user?.id || res.user?._id,
                                    sessionId: stripeSessionId,
                                }),
                            })
                                .then((attachRes) => attachRes.json())
                                .then((attachData) => {
                                    if (!attachData?.success) {
                                        alert(attachData?.message || 'Payment was completed but billing link failed. Contact support.');
                                    }
                                    setShowAppPrompt(true);
                                })
                                .catch(() => {
                                    alert('Payment was completed but billing link failed. Contact support.');
                                    setShowAppPrompt(true);
                                });
                        } else if (shouldBill) {
                            fetch("https://crewcoin.herokuapp.com/billing/create-checkout-session", {
                                method: "POST",
                                headers: {
                                    Accept: "application/json",
                                    "Content-Type": "application/json",
                                },
                                body: JSON.stringify({
                                    userId: res.user?.id || res.user?._id,
                                    plan,
                                    billingInterval,
                                }),
                            })
                                .then((checkoutRes) => checkoutRes.json())
                                .then((checkoutData) => {
                                    if (checkoutData?.checkoutUrl) {
                                        window.location.href = checkoutData.checkoutUrl;
                                        return;
                                    }

                                    setShowAppPrompt(true);
                                })
                                .catch(() => {
                                    setShowAppPrompt(true);
                                });
                        } else {
                            setShowAppPrompt(true);
                        }

                    } else {
                        if (res.message) {
                            alert(res.message);
                            setDisable(false);
                        } else {
                            alert(res.err.message);
                            setDisable(false);
                        }
                    }
                })
                .catch(err => {
                    console.log(err);
                    alert("Something went wrong")
                }
                );
            setDisable(true)
        }
        setTimeout(() => {
            setDisable(false)
        }, 2000)
    }

    function continueToDashboard() {
        navigate('/dashboard', { state: { user: signedUpUser || user } });
    }

    return (
        <div>
            <nav id='menu' className='navbar  navbar-default navbar-fixed-top'>
                <div className='container'>
                    <div className='navbar-header'>

                        <button
                            type='button'
                            className='navbar-toggle collapsed'
                            data-toggle='collapse'
                            data-target='#bs-example-navbar-collapse-1'
                        >
                            {' '}
                            <span className='sr-only'>Toggle navigation</span>{' '}
                            <span className='icon-bar'></span>{' '}
                            <span className='icon-bar'></span>{' '}
                            <span className='icon-bar'></span>{' '}
                        </button>
                        <ul className='navbar-nav navbar-left'>

                            <li>
                                <Link to="/">`
                                    <img alt="crewcoinlogo" className="crewcoinSm" src={'../img/crewcoinlogo.png'} />
                                </Link>
                            </li>
                            <li>

                            </li>
                        </ul>

                    </div>

                    <div
                        className='collapse navbar-collapse'
                        id='bs-example-navbar-collapse-1'
                    >
                        <ul className='nav navbar-nav navbar-right'>
                            <li>
                                <Link to="/">
                                    Features
                                </Link>
                            </li>
                            <li>
                                <Link to="/">
                                    About
                                </Link>
                            </li>
                            <li>
                                <Link to="/">
                                    App
                                </Link>
                            </li>
                            <li>
                                <Link to="/">
                                    Testimonials
                                </Link>
                            </li>
                            <li>
                                <Link to="/pricing">Sign Up</Link>
                            </li>
                            <li>
                                <Link to="/login">Login</Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
            <div id='signup'>
                <div className='container mt-5'>
                    <div className='row'>
                        <div className='col-md-6 col-md-offset-3 text-center'>
                            <h2 className='gold'>Setup a new organization</h2>
                            <p className='lead'>
                                Create a new organization to get started with Crew Coin.
                            </p>
                            <form>
                                <div className='row'>
                                    <div className='col-xs-6'>
                                        <div className='form-group'>
                                            <label>First Name</label>
                                            <Input
                                                type='text'
                                                className='form-control'
                                                placeholder='First Name'
                                                name='firstName'
                                                required
                                                onChange={(value) => setData({ ...formData, firstName: value.target.value })}
                                            />
                                        </div>
                                    </div>
                                    <div className='col-xs-6'>
                                        <div className='form-group'>
                                            <label>Last Name</label>
                                            <Input
                                                type='text'
                                                className='form-control'
                                                placeholder='Last Name'
                                                name='lastName'
                                                required
                                                onChange={(value) => setData({ ...formData, lastName: value.target.value })}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className='row'>
                                    <div className='col-xs-6'>
                                        <div className='form-group'>
                                            <label>Username</label>
                                            <Input
                                                type='email'
                                                className='form-control'
                                                placeholder='Email'
                                                name='username'
                                                required
                                                value={formData.username || ''}
                                                disabled={Boolean(stripeSessionId)}
                                                onChange={(value) => setData({ ...formData, username: value.target.value.toLowerCase() })}
                                            />
                                        </div>
                                    </div>
                                    <div className='col-xs-6'>
                                        <div className='form-group'>
                                            <label>Organization Name</label>
                                            <Input
                                                type='text'
                                                className='form-control'
                                                placeholder='Organization Name'
                                                name='organization'
                                                required
                                                onChange={(value) => setData({ ...formData, organization: value.target.value })}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-xs-6'>
                                        <div className='form-group'>
                                            <label>Phone Number</label>
                                            <Input
                                                type='phone'
                                                className='form-control'
                                                placeholder='Phone Number'
                                                name='phone'
                                                required
                                                onChange={(value) => setData({ ...formData, phone: value.target.value })}
                                            />
                                        </div>
                                    </div>
                                    <div className='col-xs-6'>
                                        <div className='form-group'>
                                            <label>Portal Id</label>
                                            <Input
                                                type='text'
                                                className='form-control'
                                                maxLength={4}
                                                placeholder='4 digit alpha-numeric'
                                                name='siteNumber'
                                                required
                                                onChange={(value) => setData({ ...formData, siteNumber: value.target.value })}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-xs-6'>
                                        <div className='form-group'>
                                            <Input
                                                type='password'
                                                className='form-control'
                                                placeholder='Password'
                                                name='password'
                                                required
                                                onChange={(value) => setData({ ...formData, password: value.target.value })}
                                            />
                                        </div>
                                    </div>
                                    <div className='col-xs-6'>
                                        <div className='form-group'>
                                            <Input
                                                type='password'
                                                className='form-control'
                                                placeholder='Confirm Password'
                                                name='confirmPassword'
                                                required
                                                onChange={(value) => setData({ ...formData, confirmpassword: value.target.value })}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-xs-8 col-xs-offset-2'>
                                        <div className='form-group'>
                                            <Input
                                                type='select'
                                                className='form-control'
                                                required
                                                onChange={(value) => setData({ ...formData, type: value.target.value })}
                                            >
                                                <option value="" disabled selected>Select Your Organization Type</option>
                                                <option value='restaurant'>Restaurant</option>
                                                <option value='retail'>Retail</option>
                                                <option value='manufacturing'>Manufacturing</option>
                                                <option value='other'>Other</option>
                                            </Input>

                                        </div>
                                    </div>
                                </div>

                                <div className='row'>
                                    <div className='col-xs-12'>
                                        <div
                                            style={{
                                                border: '1px solid #e5e7eb',
                                                borderRadius: 12,
                                                padding: '12px 14px',
                                                marginBottom: 16,
                                                background: '#f8fafc',
                                                textAlign: 'left',
                                            }}
                                        >
                                            <div style={{ fontSize: 12, color: '#64748b', textTransform: 'uppercase', letterSpacing: '.06em' }}>
                                                Selected Plan
                                            </div>
                                            <div style={{ fontSize: 16, fontWeight: 700, color: '#0f172a' }}>
                                                {plan.charAt(0).toUpperCase() + plan.slice(1)} · {billingInterval === 'annual' ? 'Annual' : 'Monthly'}
                                            </div>
                                            <div style={{ fontSize: 12, color: '#64748b', marginTop: 4 }}>
                                                Need a different plan? <Link to='/pricing'>Go back to pricing</Link>.
                                            </div>
                                            {stripeSessionId ? (
                                                <div style={{ fontSize: 12, color: '#0369a1', marginTop: 6 }}>
                                                    Stripe payment verified. Use the same email to finish admin setup.
                                                </div>
                                            ) : null}
                                        </div>
                                    </div>
                                </div>

                                <button type='button' disabled={disable} onClick={
                                    () => {

                                        if (stripeSessionId && !stripeSessionValidated) {
                                            alert('Verifying payment session. Please wait a moment and try again.');
                                            return;
                                        }

                                        if (formData.password === formData.confirmpassword && formData.password.length > 7 && /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{6,16}$/.test(formData.password)) {
                                            if (/.+@.+\.[A-Za-z]+$/.test(formData.username)) {
                                                handleForm();

                                            } else {
                                                alert("Please enter valid email");
                                            }
                                        } else {
                                            alert(
                                                "Passwords do not match. Password Must be at least 8 characters long and contain at least one number and one special character",
                                            );
                                        }
                                    }
                                }
                                    className='btn mb5 btn-custom btn-lg page-scroll mb-5' >
                                    Sign Up
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            {showAppPrompt ? (
                <div
                    style={{
                        position: 'fixed',
                        inset: 0,
                        backgroundColor: 'rgba(0,0,0,0.55)',
                        zIndex: 9999,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: 16,
                    }}
                >
                    <div
                        style={{
                            width: 'min(540px, 100%)',
                            background: '#fff',
                            borderRadius: 14,
                            padding: '22px 18px',
                            textAlign: 'center',
                            boxShadow: '0 16px 36px rgba(15,23,42,0.28)',
                        }}
                    >
                        <h3 className="gold" style={{ marginTop: 0 }}>Account created 🎉</h3>
                        <p style={{ marginBottom: 16 }}>Next step: download the Crew Coin app to start rewarding your team.</p>
                        <div style={{ display: 'flex', justifyContent: 'center', gap: 12, flexWrap: 'wrap', marginBottom: 18 }}>
                            <a href="https://apps.apple.com/us/app/crew-coin/id1611964163" target="_blank" rel="noreferrer">
                                <img alt="App Store" className="appstore" src={'./img/appstore.png'} />
                            </a>
                            <a href="https://play.google.com/store/apps/details?id=com.davwilliams.crewcoinapp" target="_blank" rel="noreferrer">
                                <img alt="Google Play" className="appstore" src={'./img/playstore.png'} />
                            </a>
                        </div>
                        <button type="button" className="btn" onClick={continueToDashboard}>
                            Continue to Dashboard
                        </button>
                    </div>
                </div>
            ) : null}
        </div>
    );
}


